import { Button, FontIcon, HeroBlock, Text } from '@intigral/shared';
import { useConfigurationSections } from '../../../../hooks/useConfiguration';
import { Trailer } from './Trailer';
import { useMediaQuery } from '@intigral/hooks';
import h from '../../../../helpers/common';
import withResponsiveStyles from '@intigral/shared/components/hocs/ResponiseStyles/withResponsiveStyles';
import { __ } from '../../../../translations';
import { iPosterProps } from '../../types/iDetailOverlay';

export const Poster: React.FC<iPosterProps> = ({
    showMoviePoster,
    showAutoTrailer,
    item,
    trailerUrl,
    isMuted,
    handleShowTrailer,
}) => {
    const ButtonStyle = withResponsiveStyles(Button);

    const { autoTrailerCarousel } = useConfigurationSections();
    const isMobile = useMediaQuery('(max-width: 924px)');

    return (
        <>
            {showMoviePoster ? (
                <HeroBlock
                    heading={
                        <Text as="h2" variant="h2" size={{ default: '24', md: '36' }} alignment="start" margin="0">
                            {item?.text}
                        </Text>
                    }
                    picture={h.getImagizerUrl(
                        item.image_landscape,
                        (autoTrailerCarousel as any)?.overlay_landscape_image_width || 750,
                        (autoTrailerCarousel as any)?.overlay_landscape_image_height || 0,
                        (autoTrailerCarousel as any)?.overlay_landscape_image_quality || 100
                    )}
                    compact
                    detail
                />
            ) : (
                <>
                    {showAutoTrailer && item?.trailerMediaUrl ? (
                        <HeroBlock
                            heading={
                                <Text
                                    as="h2"
                                    variant="h2"
                                    size={{ default: '24', md: '36' }}
                                    alignment="start"
                                    margin="0"
                                >
                                    {item?.text}
                                </Text>
                            }
                            picture={
                                trailerUrl ? (
                                    <Trailer source={trailerUrl} isMuted={isMuted} item={item}>
                                        {isMobile ? (
                                            <ButtonStyle
                                                marginTop="2x"
                                                compact
                                                secondary
                                                className="trailer"
                                                onClick={handleShowTrailer}
                                            >
                                                <span>{__('watch_trailer')}</span>{' '}
                                                <FontIcon name="play-outline" size="smaller" md="smaller" />
                                            </ButtonStyle>
                                        ) : null}
                                    </Trailer>
                                ) : null
                            }
                            compact
                            detail
                        />
                    ) : (
                        <HeroBlock
                            heading={
                                <Text
                                    as="h2"
                                    variant="h2"
                                    size={{ default: '24', md: '36' }}
                                    alignment="start"
                                    margin="0"
                                >
                                    {item?.text}
                                </Text>
                            }
                            picture={
                                h.getImagizerUrl(
                                    item.image_landscape,
                                    (autoTrailerCarousel as any)?.overlay_landscape_image_width || 750,
                                    (autoTrailerCarousel as any)?.overlay_landscape_image_height || 0,
                                    (autoTrailerCarousel as any)?.overlay_landscape_image_quality || 100
                                ) || null
                            }
                            compact
                            detail
                        />
                    )}
                </>
            )}
        </>
    );
};
